import React, { useEffect } from "react";
import { Popover, OverlayTrigger, Dropdown, MenuItem } from "react-bootstrap";

import Select, { createFilter } from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRetweet, faSearch, faUndo } from "@fortawesome/free-solid-svg-icons";

import GoogleSlidesIcon from "images/google-slides.svg";
import LookerIcon from "images/looker.svg";
import LookerIconDisabled from "images/looker-disabled.svg";

import { Button, Icon } from "aible";
import { LineInput } from "components/Inputs/LineInput";

import HexagonContainer from "containers/Next/Hexagon";

import { DATASET_REFRESH_RATE_OPTIONS } from "containers/SchemaMonitor/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import * as nextReducer from "containers/Next/NextReducer";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

import { DEFAULT_MIN_EXPLORE_SAMPLE_SIZE } from "utils/insight/insights";

import { GoogleLogin, GoogleLogout } from "react-google-login";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const CLIENT_ID = "";
let ACCESS_TOKEN = "";

import { rgb } from "d3-color";
import DateSelector from "../ChatGPT/Dashboard/DateSelector";
import DateInput from "../ChatGPT/Dashboard/DateInput";
import { format, isAfter, isBefore, isEqual, max, min, parse } from "date-fns";
import ComparisonChartOptions from "@/components/Next/Dashboard/ComparisonChartOptions";
import { useDispatch, useSelector } from "react-redux";
import LinkedComparisonSelect from "./Dashboard/LinkedComparisonSelect";
import SmallDateChart, { getDatefnsParseFormat } from "@/components/Tiles/Sense/SmallDateChart";
import { AutoSizer } from "react-virtualized";
import { Bar, BarChart, Cell, Pie, PieChart, ReferenceLine, Tooltip, XAxis } from "recharts";
import { calculateDateValues } from "@/components/Tiles/Sense/ActionsPanel";
import { Popover as ShadcnPopover, PopoverContent, PopoverTrigger } from "@/aible/Popover/Popover";

const CustomOption = (option) => {
  return (
    <div className={styles.cOption} {...option?.innerProps}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        {option?.data?.label}
        {option?.data?.itemsSize > 0 && (
          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              borderRadius: "5px",
              padding: "2px 5px",
              backgroundColor: "var(--light-purple)"
            }}
          >
            {option?.data?.itemsSize}
          </span>
        )}
      </div>
      <div className={styles.cOptionOuterBar}>
        <div
          className={styles.cOptionInnerBar}
          style={{
            width: option?.data?.scaleScore * 100 + "%",
            background: option?.data?.color
          }}
        />
      </div>
    </div>
  );
};

export default class NextSearch extends React.PureComponent {
  constructor(props) {
    super(props);

    /* Todo: Google Slides init
    const initClient = () =>
      gapi.client.init({
        clientId: CLIENT_ID,
        scope:
          "https://www.googleapis.com/auth/spreadsheets https://www.googleapis.com/auth/presentations",
      });

    gapi.load("client:auth2", initClient);
    */

    this.state = {
      searchValues: [],
      isMakeLive: undefined,
      isDashboardBuilding: false,
      isGoogleLogin: false,
      isOverflowHidden: false,
      showWhatsChangedDropdown: false
      // tempComparisonOptions: {...this.props.comparisonOptions},
    };
  }

  buildCellRequest(column, row, value) {
    return {
      repeatCell: {
        range: {
          startColumnIndex: column,
          endColumnIndex: column + 1,
          startRowIndex: row,
          endRowIndex: row + 1,
          sheetId: 0
        },
        cell: {
          userEnteredValue: isNaN(value)
            ? {
                stringValue: value
              }
            : { numberValue: value }
        },
        fields: "*"
      }
    };
  }

  updateSheetFirstOrder(sheetId, chart, startRow = 0) {
    let requests = [];

    const retData = chart?.chart?.data
      ? chart?.chart?.data.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0))
      : [];

    requests.push(this.buildCellRequest(0, startRow, chart?.metadata?.properties?.[0]?.column));
    requests.push(this.buildCellRequest(1, startRow, chart?.narrative?.title));

    for (let i = 0; i < retData.length; i++) {
      const dItem = retData?.[i];

      requests.push(this.buildCellRequest(0, i + 1 + startRow, dItem.name));

      requests.push(this.buildCellRequest(1, i + 1 + startRow, dItem.y === undefined ? 0 : dItem.y));
    }

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: requests
      })
    }).then((r) => this.handleResponse(r));
  }

  updateSheet(sheetId, chart, startRow = 0) {
    let requests = [];

    const retData = chart?.chart?.data
      ? chart?.chart?.data.sort((a, b) => (a.name < b.name ? -1 : b.name < a.name ? 1 : 0))
      : [];

    requests.push(this.buildCellRequest(0, startRow, chart?.metadata?.properties?.[0]?.column));
    requests.push(this.buildCellRequest(1, startRow, chart?.narrative?.conditionsLabel));
    requests.push(this.buildCellRequest(2, startRow, chart?.metadata?.properties?.[1]?.column + " is all other"));

    for (let i = 0; i < retData.length; i++) {
      const dItem = retData?.[i];

      requests.push(this.buildCellRequest(0, i + 1 + startRow, dItem.name));

      requests.push(this.buildCellRequest(1, i + 1 + startRow, dItem.y === undefined ? 0 : dItem.y));
      requests.push(this.buildCellRequest(2, i + 1 + startRow, dItem.otherY));
    }

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: requests
      })
    }).then((r) => this.handleResponse(r));
  }

  updateSheetLineChart(sheetId, chart, startRow = 0) {
    const retData = chart?.data.sort((a, b) => {
      if (isNaN(a.name) || isNaN(b.name)) {
        return a.name < b.name ? -1 : b.name < a.name ? 1 : 0;
      } else {
        return Number(a.name) < Number(b.name) ? -1 : Number(b.name) < Number(a.name) ? 1 : 0;
      }
    });
    const lineKeys =
      retData?.[0] === undefined
        ? []
        : Object.keys(retData[0])
            .filter(
              (cKey) => cKey !== "count" && cKey !== "name" && cKey !== "column" && cKey !== "min" && cKey !== "max"
            )
            .filter((c, i) => i < 5);

    let requests = [];

    console.log("what is lineKeys chart", lineKeys, chart);

    requests.push(this.buildCellRequest(0, startRow, chart?.title));

    lineKeys.forEach((lineKey, i) => {
      requests.push(this.buildCellRequest(i + 1, startRow, lineKey));
    });

    for (let i = 0; i < retData.length; i++) {
      const dItem = retData?.[i];

      requests.push(this.buildCellRequest(0, i + 1 + startRow, dItem.name));

      lineKeys.forEach((lineKey, j) => {
        requests.push(this.buildCellRequest(j + 1, i + 1 + startRow, dItem[lineKey]));
      });
    }

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: requests
      })
    }).then((r) => this.handleResponse(r));
  }

  handleExport() {
    const { isGoogleMode, searchInsights, pinnedHexList, activeTab } = this.props;

    const isSearchExport = searchInsights && searchInsights.length > 0;

    if (isSearchExport) {
      return this.exportSearch(searchInsights);
    } else if (isGoogleMode || activeTab === "DASHBOARD") {
      return this.exportDashboard();
    } else {
      return this.exportSearch(pinnedHexList);
    }
  }

  timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async exportDashboard() {
    const { allCharts } = this.props;

    this.setState({ isDashboardBuilding: true });

    console.log("Export dashboard!", allCharts, this.props);

    let startRow = 0;

    try {
      const sheetResponse = await this.createSheet();
      const presResponse = await this.createPresentation();

      console.log("what is sheet?, pres", sheetResponse, presResponse);

      const sheetId = sheetResponse?.spreadsheetId;
      const presentationId = presResponse?.presentationId;

      const shapeResponse = await this.addShape(presentationId, "p");

      console.log("what is shape??", shapeResponse);

      const shapeId = shapeResponse?.replies[0]?.createShape?.objectId;

      const updateShapeResponse = await this.updateShape(presentationId, shapeId);

      const imgLogoResp = await this.addImageToSlide(
        presentationId,
        "p",
        "https://bigquery.d.aiplusi.com/d4c67630dff9577d09803147739f1ac4.png",
        {
          scaleX: 1,
          scaleY: 1,
          translateX: 300000,
          translateY: 20000,
          unit: "EMU"
        },
        { magnitude: 1000000, unit: "EMU" },
        { magnitude: 2000000, unit: "EMU" }
      );

      const imgPatternResp = await this.addImageToSlide(
        presentationId,
        "p",
        "https://bigquery.d.aiplusi.com/a950005562eb24b89784809e9311056c.png",
        undefined
      );

      console.log("what is updateShape??", updateShapeResponse);

      window.open("https://docs.google.com/presentation/d/" + presentationId);

      let slideIndex = 0;
      for (const chart of allCharts) {
        console.log("what is chart?", chart);

        const slideId = "slideId" + slideIndex;
        const slideResponse = await this.createSlide(presentationId, slideId);

        console.log("new slide", slideResponse);

        const uResponse = await this.updateSheetLineChart(sheetId, chart, startRow);

        const aResponse = await this.addChartLine(sheetId, chart, startRow);

        const cResp = await this.addChartsToSlide(
          sheetId,
          presentationId,
          slideId,
          aResponse?.replies?.[0]?.addChart?.chart?.chartId,
          0
        );

        console.log("update sheet response", uResponse);

        startRow += chart?.data.length + 2;

        const secondCharts = chart?.secondaryCharts.filter((c, i) => i < 3);

        let sIndex = 0;
        for (const sChart of secondCharts) {
          const bResponse = await this.updateSheet(sheetId, sChart, startRow);
          const cResponse = await this.addChart(sheetId, sChart, startRow);

          const cRespSecond = await this.addChartsToSlide(
            sheetId,
            presentationId,
            slideId,
            cResponse?.replies?.[0]?.addChart?.chart?.chartId,
            sIndex + 1
          );

          startRow += sChart?.chart.data.length + 2;
          sIndex++;
        }

        const smallShapeResponse = await this.addShapeSmall(presentationId, slideId, 0);

        const smallShapeId = smallShapeResponse?.replies?.[0]?.createShape?.objectId;

        if (smallShapeId !== undefined) {
          const upSmallShape = await this.updateShape(presentationId, smallShapeId);

          const textResponse = await this.updateShapeText(
            presentationId,
            smallShapeId,
            chart?.title || chart?.narrative?.title
          );
          const textStyleResp = await this.updateTextStyle(presentationId, smallShapeId, true);
        }

        let nIndex = 0;
        for (const sChart of secondCharts) {
          const sResp = await this.addShapeSmall(presentationId, slideId, nIndex + 1);
          const sShapeId = sResp?.replies?.[0]?.createShape?.objectId;

          if (sShapeId !== undefined) {
            const sUpdateResp = await this.updateShape(presentationId, sShapeId);
            const sTextResp = await this.updateShapeText(presentationId, sShapeId, sChart?.narrative?.title);
            const textStyleResp = await this.updateTextStyle(presentationId, sShapeId);
          }

          nIndex++;
        }

        slideIndex++;
      }

      this.setState({ isDashboardBuilding: false });

      return Promise.resolve();
    } catch (e) {
      console.log("Export Error: ", e);
      this.setState({ isDashboardBuilding: false });
    }
  }

  async exportSearch(searchInsights) {
    const retData = searchInsights;

    this.setState({ isDashboardBuilding: true });

    console.log("Export search!", retData, this.props);

    let startRow = 0;

    const sheetResponse = await this.createSheet();
    const presResponse = await this.createPresentation();

    console.log("what is sheet?, pres", sheetResponse, presResponse);

    const sheetId = sheetResponse?.spreadsheetId;
    const presentationId = presResponse?.presentationId;

    window.open("https://docs.google.com/presentation/d/" + presentationId);

    let slideIndex = 0;
    for (const chart of retData) {
      console.log("what is chart?", chart);

      const slideId = slideIndex === 0 ? "p" : "slideId" + slideIndex;
      if (slideIndex > 0) {
        const slideResponse = await this.createSlide(presentationId, slideId);
        console.log("new slide", slideResponse);
      }

      const uResponse =
        chart?.metadata?.properties && chart?.metadata?.properties.length === 1
          ? await this.updateSheetFirstOrder(sheetId, chart, startRow)
          : await this.updateSheet(sheetId, chart, startRow);

      const aResponse =
        chart?.metadata?.properties && chart?.metadata?.properties.length === 1
          ? await this.addChartFirstOrder(sheetId, chart, startRow)
          : await this.addChart(sheetId, chart, startRow);

      this.addChartsToSlide(sheetId, presentationId, slideId, aResponse?.replies?.[0]?.addChart?.chart?.chartId, -1);

      console.log("update sheet response", uResponse);

      startRow += chart?.chart?.data.length + 2;

      slideIndex++;
    }

    this.setState({ isDashboardBuilding: false });

    return Promise.resolve();
  }

  createSheet() {
    return fetch(`https://sheets.googleapis.com/v4/spreadsheets`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        properties: { title: "Aible Insights Spreadsheet" }
      })
    }).then((r) => this.handleResponse(r));
  }

  createPresentation() {
    return fetch(`https://slides.googleapis.com/v1/presentations`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({ title: "Aible Insights" })
    }).then((r) => this.handleResponse(r));
  }

  createSlide(presentationId, slideId) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [{ createSlide: { objectId: slideId } }]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChartLine(sheetId, chart, startRow) {
    const { dataset } = this.props;

    const retData = chart?.data;
    const lineKeys =
      retData?.[0] === undefined
        ? []
        : Object.keys(retData[0])
            .filter(
              (cKey) => cKey !== "count" && cKey !== "name" && cKey !== "column" && cKey !== "min" && cKey !== "max"
            )
            .filter((c, i) => i < 5);

    let series = [];

    lineKeys.forEach((lineKey, i) => {
      const color = chart?.colors[i];
      const rColor = rgb(color);

      series.push({
        series: {
          sourceRange: {
            sources: [
              {
                sheetId: 0,
                startRowIndex: startRow,
                endRowIndex: startRow + retData.length + 1,
                startColumnIndex: i + 1,
                endColumnIndex: i + 2
              }
            ]
          }
        },
        colorStyle: {
          rgbColor: {
            red: rColor.r / 255,
            green: rColor.g / 255,
            blue: rColor.b / 255,
            alpha: rColor.opacity
          }
        },
        targetAxis: "LEFT_AXIS"
      });
    });

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            addChart: {
              chart: {
                spec: {
                  title: chart?.title,
                  basicChart: {
                    chartType: "LINE",
                    legendPosition: "BOTTOM_LEGEND",
                    axis: [
                      {
                        position: "BOTTOM_AXIS",
                        title: ""
                      },
                      {
                        position: "LEFT_AXIS",
                        title: dataset?.outcome
                      }
                    ],
                    domains: [
                      {
                        domain: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 0,
                                endColumnIndex: 1
                              }
                            ]
                          }
                        }
                      }
                    ],
                    series: series,
                    headerCount: 1
                  }
                },
                position: {
                  newSheet: true
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addShape(presentationId, slideId) {
    const { dataset } = this.props;

    const eFullHeight = {
      magnitude: 5143500,
      unit: "EMU"
    };

    const eFullWidth = {
      magnitude: 9144000,
      unit: "EMU"
    };

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createShape: {
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: eFullHeight,
                  width: eFullWidth
                }
              },
              shapeType: "TEXT_BOX"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addShapeSmall(presentationId, slideId, chartIndex) {
    const eWidthLarge = {
      magnitude: 5000000,
      unit: "EMU"
    };

    const eWidthSmall = {
      magnitude: 3000000,
      unit: "EMU"
    };

    const eHeightSmall = {
      magnitude: 300000,
      unit: "EMU"
    };

    const eHeightLarge = {
      magnitude: 370000,
      unit: "EMU"
    };

    const translateX =
      chartIndex === -1
        ? 0
        : chartIndex === 0
          ? 1900000
          : chartIndex === 1
            ? 0
            : chartIndex === 2
              ? 3000000
              : chartIndex === 3
                ? 6000000
                : 6000000;
    const translateY =
      chartIndex === -1
        ? 0
        : chartIndex === 0
          ? 10000
          : chartIndex === 1
            ? 3200000
            : chartIndex === 2
              ? 3200000
              : chartIndex === 3
                ? 3200000
                : 3200000;

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createShape: {
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: chartIndex === 0 ? eHeightLarge : eHeightSmall,
                  width: chartIndex === 0 ? eWidthLarge : eWidthSmall
                },
                transform: {
                  scaleX: 1,
                  scaleY: 1,
                  translateX: translateX,
                  translateY: translateY,
                  unit: "EMU"
                }
              },
              shapeType: "TEXT_BOX"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  updateTextStyle(presentationId, shapeId, isLarge = false) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            updateTextStyle: {
              objectId: shapeId,
              style: {
                foregroundColor: {
                  opaqueColor: {
                    rgbColor: {
                      red: 1,
                      green: 1,
                      blue: 1
                    }
                  }
                },
                fontSize: {
                  magnitude: isLarge ? 13 : 9,
                  unit: "PT"
                }
              },
              fields: "foregroundColor.opaqueColor.rgbColor,fontSize"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  updateShapeText(presentationId, shapeId, text) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            insertText: {
              objectId: shapeId,
              text: text
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  updateShape(presentationId, shapeId, chartIndex) {
    const { dataset } = this.props;

    const eFullHeight = {
      magnitude: 5143500,
      unit: "EMU"
    };

    const eFullWidth = {
      magnitude: 9144000,
      unit: "EMU"
    };

    const emu4M = {
      magnitude: 3300000,
      unit: "EMU"
    };

    const eSmall = {
      magnitude: 3000000,
      unit: "EMU"
    };

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            updateShapeProperties: {
              objectId: shapeId,
              shapeProperties: {
                shapeBackgroundFill: {
                  solidFill: {
                    color: {
                      rgbColor: {
                        red: 76.0 / 255.0,
                        green: 51.0 / 255.0,
                        blue: 114.0 / 255.0
                      }
                    }
                  }
                }
              },
              fields: "shapeBackgroundFill.solidFill.color"
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChart(sheetId, chart, startRow) {
    const { dataset } = this.props;

    const retData = chart?.chart?.data;

    const rColor = rgb(chart?.color);

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            addChart: {
              chart: {
                spec: {
                  title: chart?.narrative?.title,
                  basicChart: {
                    chartType: "COLUMN",
                    legendPosition: "BOTTOM_LEGEND",
                    axis: [
                      {
                        position: "BOTTOM_AXIS"
                      },
                      {
                        position: "LEFT_AXIS",
                        title: dataset?.outcome
                      }
                    ],
                    domains: [
                      {
                        domain: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 0,
                                endColumnIndex: 1
                              }
                            ]
                          }
                        }
                      }
                    ],
                    series: [
                      {
                        series: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 1,
                                endColumnIndex: 2
                              }
                            ]
                          }
                        },
                        colorStyle: {
                          rgbColor: {
                            red: rColor.r / 255,
                            green: rColor.g / 255,
                            blue: rColor.b / 255,
                            alpha: rColor.opacity
                          }
                        },
                        targetAxis: "LEFT_AXIS"
                      },
                      {
                        series: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 2,
                                endColumnIndex: 3
                              }
                            ]
                          }
                        },
                        colorStyle: {
                          rgbColor: {
                            red: 153 / 255,
                            green: 153 / 255,
                            blue: 153 / 255,
                            alpha: 1
                          }
                        },
                        targetAxis: "LEFT_AXIS"
                      }
                    ],
                    headerCount: 1
                  }
                },
                position: {
                  newSheet: true
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChartFirstOrder(sheetId, chart, startRow) {
    const { dataset } = this.props;

    const retData = chart?.chart?.data;

    const rColor = rgb(chart?.color);

    return fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            addChart: {
              chart: {
                spec: {
                  title: chart?.narrative?.title,
                  basicChart: {
                    chartType: "COLUMN",
                    legendPosition: "BOTTOM_LEGEND",
                    axis: [
                      {
                        position: "BOTTOM_AXIS"
                      },
                      {
                        position: "LEFT_AXIS",
                        title: dataset?.outcome
                      }
                    ],
                    domains: [
                      {
                        domain: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 0,
                                endColumnIndex: 1
                              }
                            ]
                          }
                        }
                      }
                    ],
                    series: [
                      {
                        series: {
                          sourceRange: {
                            sources: [
                              {
                                sheetId: 0,
                                startRowIndex: startRow,
                                endRowIndex: startRow + retData.length + 1,
                                startColumnIndex: 1,
                                endColumnIndex: 2
                              }
                            ]
                          }
                        },
                        colorStyle: {
                          rgbColor: {
                            red: rColor.r / 255,
                            green: rColor.g / 255,
                            blue: rColor.b / 255,
                            alpha: rColor.opacity
                          }
                        },
                        targetAxis: "LEFT_AXIS"
                      }
                    ],
                    headerCount: 1
                  }
                },
                position: {
                  newSheet: true
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addImageToSlide(
    presentationId,
    slideId,
    url,
    transform,
    height = { magnitude: 5143500, unit: "EMU" },
    width = {
      magnitude: 9144000,
      unit: "EMU"
    }
  ) {
    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createImage: {
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: height,
                  width: width
                },
                transform: transform
              },
              url: url
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  addChartsToSlide(sheetId, presentationId, slideId, chartId, chartIndex, slideIndex) {
    console.log("what is chartId chartIndex", chartId, chartIndex);
    const emu4M = {
      magnitude: 3300000,
      unit: "EMU"
    };

    const eWidth = {
      magnitude: 7200000,
      unit: "EMU"
    };

    const eSmall = {
      magnitude: 3000000,
      unit: "EMU"
    };

    const eFullHeight = {
      magnitude: 5143500,
      unit: "EMU"
    };

    const eFullWidth = {
      magnitude: 9144000,
      unit: "EMU"
    };

    return fetch(`https://slides.googleapis.com/v1/presentations/${presentationId}:batchUpdate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        //update this token with yours.
        Authorization: `Bearer ${ACCESS_TOKEN}`
      },
      body: JSON.stringify({
        requests: [
          {
            createSheetsChart: {
              objectId: "MyChartId_" + chartId + "_" + chartIndex,
              spreadsheetId: sheetId,
              chartId: chartId,
              linkingMode: "LINKED",
              elementProperties: {
                pageObjectId: slideId,
                size: {
                  height: chartIndex === -1 ? eFullHeight : chartIndex === 0 ? emu4M : eSmall,
                  width: chartIndex === -1 ? eFullWidth : chartIndex === 0 ? eWidth : eSmall
                },
                transform: {
                  scaleX: 1,
                  scaleY: 1,
                  translateX:
                    chartIndex === -1
                      ? 0
                      : chartIndex === 0
                        ? 800000
                        : chartIndex === 1
                          ? 0
                          : chartIndex === 2
                            ? 3000000
                            : chartIndex === 3
                              ? 6000000
                              : 6000000,
                  translateY:
                    chartIndex === -1
                      ? 0
                      : chartIndex === 0
                        ? 0
                        : chartIndex === 1
                          ? 2700000
                          : chartIndex === 2
                            ? 2700000
                            : chartIndex === 3
                              ? 2700000
                              : 2700000,
                  unit: "EMU"
                }
              }
            }
          }
        ]
      })
    }).then((r) => this.handleResponse(r));
  }

  handleResponse(response) {
    return response.json();
  }

  renderSlidesExport(bText = "Slides") {
    const { isGoogleMode, isGoogleAuthed, updateIsGoogleAuthed } = this.props;

    const { isGoogleLogin, isDashboardBuilding } = this.state;

    const onSuccess = (res) => {
      ACCESS_TOKEN = res?.tokenObj?.access_token;
      console.log("success!:", res);

      this.handleExport();

      updateIsGoogleAuthed(true);
    };
    const onFailure = (err) => {
      console.log("failed:", err);
    };

    return (
      <div
        style={{
          marginRight: "5px"
        }}
        className={isGoogleMode ? styles.googleModeSlides : ""}
      >
        {false && (
          <GoogleLogout
            clientId={CLIENT_ID}
            buttonText="Logout"
            onLogoutSuccess={(e) => console.log("logout suc", e)}
          ></GoogleLogout>
        )}
        {isGoogleLogin ? (
          <div style={{ display: "none" }}>
            <GoogleLogin
              clientId={CLIENT_ID}
              buttonText="Sign in with Google"
              onSuccess={onSuccess}
              onFailure={onFailure}
              cookiePolicy={"single_host_origin"}
              autoLoad={true}
              isSignedOn={true}
            />
          </div>
        ) : (
          <div />
        )}
        {isDashboardBuilding ? (
          <LoadingIndicator style={{ margin: "0px" }} />
        ) : (
          <Button
            onClick={() => {
              if (isGoogleAuthed === true) {
                this.handleExport();
              } else {
                this.setState({ isGoogleLogin: true });
              }
            }}
          >
            <img
              src={GoogleSlidesIcon}
              style={{
                height: "18px",
                margin: "0 12px 0 -4px"
              }}
            />
            {bText}
          </Button>
        )}
      </div>
    );
  }

  render() {
    const {
      style,
      id,
      dataset,
      isReplay,
      isOpen,
      createDashboard,
      searchType,
      updateIsOpen,
      handleSearchInsights,
      updateSearchType,
      updateSearchNLQ,
      updateIsTransformOpen,
      isTransformOpen,
      hexSize,
      insights,
      searchOpts,
      updateIsHideSearch,
      rankedFields,
      comparisonChartsByColumn,
      isHideSearchType,
      isChatColumnSelect,
      isHideSearch,
      isOnlySearch,
      hideMargins,
      isList,
      hasModelDrivers,
      comparisonOptions,
      updateHoverGroup,
      updateSearchColumnState,
      allCharts,
      showHiddenCharts,
      updateShowHiddenCharts,
      isDashboard,
      isHideLegend,
      updateIsHideLegend,
      dashboardSize,
      updateDashboardSize,
      isAngleAxis,
      updateIsAngleAxis,
      updateDatasetSuccess,
      successOptions,
      datasetSuccess,
      updateIsDomainMin,
      updateIsShowAllDashboard,
      updateDashboardLayout,
      dashboardLayout,
      isShowAllDashboard,
      isDomainMin,
      assignTodo,
      datasetTargetValue,
      initNextDashboard,
      nextDatasets,
      originalId,
      isTestUser,
      isGoogleMode,
      isExportingLooker,
      exportToLooker,
      searchInsights,
      pinnedHexList,
      datasetId,
      openExploration,
      isOnlyValue,
      updateIgnoreInfoChartField,
      lookerSDK,
      minimumValueCount,
      updateMinimumValueCount,
      comparisonDashboardSort,
      comparisonDashBoardSortOptions,
      updateComparisonDashboardSort,
      comparisonDashboardSortOrder,
      updateComparisonDashboardSortOrder,
      comparisonDashboardSortOrderOptions,
      updateComparisonOptions,
      comparisonChartOptions,
      updateComparisonChartOptions,
      getInsightFromMetadata,
      hideMissingInCharts,
      hideOtherInCharts,
      updateHideMissingInCharts,
      updateHideOtherInCharts,
      dashboardSubchartsCount,
      updateDashboardSubchartsCount,
      activeTab,
      menuPlacement,
      searchTopStyle,
      searchSelectStyle,
      useReportIdForChatGPTReducer,
      isSimpleAgentAnalytics,
      showCollapsed = true,
      maxSearchOptionsDisplayed,
      maxSelectedOptions
    } = this.props;

    const { isOverflowHidden } = this.state;

    const isWhatsChanged = Boolean(comparisonOptions?.dateField);
    const dateFnsFormat = getDatefnsParseFormat(comparisonOptions?.currentStart);
    const searchTypeOptions = nextReducer.searchTypeOptions;

    const searchTypeValue = searchTypeOptions.find((o) => o.value === searchType) || searchTypeOptions[0];

    const outcome = dataset?.fields?.[dataset?.outcome];

    const successLabel = `${outcome?.label}${datasetSuccess?.label ? ": " + datasetSuccess.label : ""}`;

    const retScores = dataset?.field_scores;

    const maxScore = retScores !== undefined && Object.keys(retScores).reduce((a, b) => Math.max(a, retScores[b]), -10);

    // Create the default first order options
    const rankedFieldOptions = rankedFields
      .map((field, fIndex) => {
        const fKey = field?.label;

        const currProb = outcome?.inclusionProbabilities?.find((prob) => prob?.keys?.every((k) => k === fKey))?.value;

        let oColor = nextReducer.colors?.[fIndex % nextReducer.colors?.length] ?? "gray";

        return {
          label: fKey,
          value: fKey,
          field: fKey,
          oScore: currProb,
          score: currProb !== undefined ? currProb + 5 : 5,
          color: oColor,
          mScore: retScores?.[fKey] + 10000,
          scaleScore: retScores?.[fKey] / maxScore,
          hoverGroup: fIndex
        };
      })
      .filter((field) => field.value !== dataset?.outcome);

    let fieldOptions = rankedFieldOptions;

    // Whats changed needs different rankings than analytics
    if (isWhatsChanged) {
      // Get the max difference score
      const maxScore = comparisonChartsByColumn.reduce((acc, cChart) => {
        const currScore = Math.abs(cChart.total);
        return Math.max(acc, currScore);
      }, 0);
      // get the top columns from difference score
      const topFields = comparisonChartsByColumn.map((cChart) => {
        const fKey = cChart?.column;
        const currScore = Math.abs(cChart?.total);
        const fIndex = rankedFields.findIndex((field) => {
          const currField = field?.label;
          return currField === fKey;
        });
        const oColor = nextReducer.colors?.[fIndex % nextReducer.colors?.length] ?? "gray";
        return {
          label: fKey,
          value: fKey,
          field: fKey,
          oScore: currScore,
          score: currScore !== undefined ? currScore + 5 : 5,
          color: oColor,
          mScore: currScore + 10000,
          scaleScore: currScore / maxScore,
          hoverGroup: fIndex
        };
      });
      // set remaining columns to 0 score
      const remainingFields = rankedFieldOptions
        .filter((fOption) => {
          const currField = fOption.value;
          return !topFields.find((topOption) => topOption.value === currField);
        })
        .map((fOption) => {
          return {
            ...fOption,
            oScore: 0,
            score: 5,
            mScore: 10000,
            scaleScore: 0
          };
        });
      fieldOptions = [...topFields, ...remainingFields];
    }

    let searchOptions = [];
    // White screen caused by searchOpts being undefined
    // Bandaid fix here to make it not undefined, unsure why it would ever be undefined
    const selectedSearchOptionsLabels = searchOpts ? new Set(searchOpts?.map((o) => o.label)) : new Set();

    if (!isWhatsChanged) {
      fieldOptions.forEach((o, fIndex) => {
        // Adding this in to show first order Search Options on explore/dashboard
        searchOptions.push(o);
        // Adding back this field declaration for explore tab that was missing options when allCharts is [].
        const field = dataset.fields[o.value];

        const oColor = nextReducer.colors?.[fIndex % nextReducer.colors?.length] ?? "gray";

        let dashboardChart = undefined;
        if (allCharts) {
          dashboardChart = allCharts.find((aChart) => aChart.title === o.value);
        }

        if (dashboardChart) {
          (dashboardChart?.data ?? []).forEach((dRow) => {
            const value = dRow.name;

            const min = dRow?.min;
            const max = dRow?.max;

            const label = o.value + ": " + value;

            const currProb = outcome?.inclusionProbabilities?.find((prob) =>
              prob?.keys?.every((k) => k === field?.label)
            )?.value;

            if (!selectedSearchOptionsLabels.has(label)) {
              searchOptions.push({
                label: o.value + " is " + value,
                value: label,
                filterField: o.value,
                filterValue: value,
                min: min === undefined ? undefined : Number(min),
                max: max === undefined ? undefined : Number(max),
                oScore: currProb,
                score: currProb !== undefined ? currProb : 0,
                color: oColor,
                mScore: retScores?.[field?.label],
                scaleScore: retScores?.[field?.label] / maxScore
              });
            }
          });
        } else {
          // Adding back else case to fix explore tab search options when allCharts is [].
          (field?.data ?? []).forEach((v) => {
            const label = o.value + ": " + (v.updatedValue ?? v.value);

            const currProb = outcome?.inclusionProbabilities?.find((prob) =>
              prob?.keys?.every((k) => k === field?.label)
            )?.value;

            searchOptions.push({
              label: o.value + " is " + (v.updatedValue ?? v.value),
              value: label,
              filterField: o.value,
              filterValue: v.value,
              min: v.min,
              max: v.max,
              oScore: currProb,
              score: currProb !== undefined ? currProb : 0,
              color: oColor,
              mScore: retScores?.[field?.label],
              scaleScore: retScores?.[field?.label] / maxScore
            });
          });
        }
      });
    } else {
      fieldOptions
        // Remove the dateField from the options
        .filter((option) => option.value !== comparisonOptions?.dateField)
        .forEach((o, fIndex) => {
          // Adding back this field declaration for explore tab that was missing options when allCharts is [].
          const field = dataset.fields[o.value];

          if (o.field !== comparisonOptions?.dateField) {
            if (!selectedSearchOptionsLabels.has(o.label)) {
              searchOptions.push({ ...o, itemsSize: (dataset.fields?.[o.field].data ?? []).length });
            }
          }

          let oColor = nextReducer.colors?.[fIndex % nextReducer.colors?.length] ?? "gray";

          let dashboardChart = undefined;
          if (allCharts) {
            dashboardChart = allCharts.find((aChart) => aChart.title === o.value);
          }

          if (dashboardChart) {
            const dateField = comparisonOptions?.dateField;
            if (
              dataset.fields?.[o.field].type === "categorical" &&
              dataset.fields?.[o.field].data.length !== dashboardChart?.relatedCharts?.length
            ) {
              dataset.fields?.[o.field].data.forEach((d) => {
                if (
                  hideMissingInCharts &&
                  (d?.value === "{Missing}" || d?.name === "{Missing}" || d?.type === "missing")
                ) {
                  return;
                } else if (hideOtherInCharts && (d?.value === "{Other}" || d?.name === "{Other}")) {
                  return;
                } else {
                  searchOptions.push({
                    label: o.value + " is " + d.value,
                    value: o.value + ": " + o.value + " is " + d.value,
                    filterField: o.field,
                    filterValue: d.value,
                    oScore: 0,
                    score: 0,
                    color: "gray"
                  });
                }
              });
            } else {
              dashboardChart?.relatedCharts
                ?.map((chart) => {
                  return getInsightFromMetadata(chart?.metadata, false);
                })
                .filter((v) => v !== undefined)
                .forEach((v) => {
                  const label = o.value + ": " + v.title;

                  const currProb = outcome?.inclusionProbabilities?.find((prob) =>
                    prob?.keys?.every((k) => k === field?.label)
                  )?.value;

                  const cProp = v?.metadata?.properties?.find((p) => p.column !== dateField);

                  // Don't show other and missing options in dropdown if they're hidden
                  if (
                    hideMissingInCharts &&
                    (cProp?.value === "{Missing}" || cProp?.name === "{Missing}" || cProp?.type === "missing")
                  ) {
                    return;
                  } else if (hideOtherInCharts && (cProp?.value === "{Other}" || cProp?.name === "{Other}")) {
                    return;
                  }

                  // Iterate on properties to find the correct raw filterValue instead of the chart title
                  const foundProperty = (v?.metadata?.properties ?? []).find((p) => p.column === o.value);
                  const retValue = foundProperty ? foundProperty?.value : v.title;

                  // Not sure the cases where retValue was working, use a fallback for proper filterValue to fix
                  // filtering for charts with interval ranges by splicing out the "{o.value} is " from the conditionsLabel
                  const fallbackFilterValue = v?.narrative?.conditionsLabel
                    ? v.narrative.conditionsLabel.slice((o.value?.length ?? 0) + 4)
                    : undefined;

                  if (!selectedSearchOptionsLabels.has(label)) {
                    searchOptions.push({
                      label: v.title,
                      value: label,
                      filterField: o.value,
                      filterValue: retValue ?? fallbackFilterValue,
                      oScore: currProb,
                      score: currProb !== undefined ? currProb : 0,
                      color: oColor
                    });
                  }
                });
            }
          } else {
            // Adding back fallback else case to page refreshing and pivot tables being wiped out / allCharts is [].
            (field?.data ?? []).forEach?.((v) => {
              const label = o.value + ": " + (v.updatedValue ?? v.value);

              const currProb = outcome?.inclusionProbabilities?.find((prob) =>
                prob?.keys?.every((k) => k === field?.label)
              )?.value;

              searchOptions.push({
                label: o.value + " is " + (v.updatedValue ?? v.value),
                value: label,
                filterField: o.value,
                filterValue: v.value,
                min: v.min,
                max: v.max,
                oScore: currProb,
                score: currProb !== undefined ? currProb : 0,
                color: oColor,
                mScore: retScores?.[field?.label],
                scaleScore: retScores?.[field?.label] / maxScore
              });
            });
          }
        });
    }

    const isRetHide = isHideSearch === true || !insights || insights.length === 0;

    const nextDatasetOptions = nextDatasets.map((d) => ({
      label: d.outcome,
      value: d.id
    }));

    const hasSearchInsights = searchInsights && searchInsights.length > 0;

    const retDashboardLayoutOptions =
      isEnabled("dashboard-infographic") && !isWhatsChanged
        ? [
            { value: "REPORT", label: "Layout: Report" },
            { value: "INFO", label: "Benchmark View" },
            { value: "TILED", label: "Layout: Tile Dashboard" }
          ]
        : [
            { value: "REPORT", label: "Layout: Report" },
            { value: "TILED", label: "Layout: Tile Dashboard" }
          ];

    const wcSortOptions = isWhatsChanged ? comparisonDashBoardSortOptions : [];

    const isLookerValid =
      dataset?.source?.url.startsWith("gs://") &&
      (dataset?.source?.content?.type != "CONNECTION_METADATA" || dataset?.source?.content?.provider != "BIGQUERY");

    let searchStyle =
      lookerSDK !== undefined
        ? { position: "relative" }
        : isOnlyValue
          ? { position: "relative", height: "50px" }
          : isReplay
            ? { pointerEvents: "none", opacity: "0.7" }
            : {};

    const field = dataset?.fields?.[comparisonOptions?.dateField];

    const dates = (field?.data ?? []).map((d) => ({ value: d.value, ["Total Rows"]: d.count }));

    const filteredDates = dates?.filter((d) => d?.value !== "{Missing}");
    const getNumberOfMissingDates = () => {
      if (filteredDates?.length > 0 && (dates ?? [])?.length - filteredDates?.length === 1) {
        if (dataset?.mappings) {
          const fieldIndex = dataset?.fields?.[comparisonOptions?.dateField]?.index;
          const dateMappingMissing = dataset?.mappings?.[fieldIndex]?.[2]?.missing;
          return dateMappingMissing;
        }
        return undefined;
      }

      return 0;
    };

    const getRowsIgnoredText = () => {
      const numberOfMissingDates = getNumberOfMissingDates();
      if (numberOfMissingDates > 0) {
        return `rows ignored (including ${numberOfMissingDates} missing ${numberOfMissingDates === 1 ? "date" : "dates"} which cannot be selected).`;
      }
      if (numberOfMissingDates === undefined) {
        return "rows ignored (including some missing dates which cannot be selected).";
      }
      return "rows ignored.";
    };

    const dateOptions = filteredDates.map((d) => {
      return {
        label: d.value,
        value: d.value
      };
    });

    const dateAnalysisState = {
      ...comparisonOptions,
      selectedDateField: dataset?.fields?.[comparisonOptions?.dateField] || undefined,
      dateAnalysisTarget: "EXPLORE"
    };

    const {
      currentStart,
      currentEnd,
      referenceStart,
      referenceEnd,
      dateRowsExcluded,
      dateRowsBefore,
      dateFieldMax,
      dateRowsAfter,
      dateAnalysisTarget
    } = calculateDateValues(dataset, dateAnalysisState);

    const pieData = [
      {
        name: "rows ignored",
        value: dateRowsExcluded,
        color: "#C8CAD4"
      },
      {
        name: " training rows",
        value: dateRowsBefore,
        color: "#8884d8"
      },
      {
        name: " comparison rows",
        value: dateRowsAfter,
        color: "#34D399"
      }
    ];

    const maxShownSearchOptions = maxSearchOptionsDisplayed ?? 1;

    // For Simple Agent Analytics we are disabling selection after maxSelectedOptions is reached
    const getIsSearchOptionsDisabled = () => {
      if (maxSelectedOptions > 0) {
        return searchOpts?.length >= maxSelectedOptions;
      }
      return false;
    };

    // Replacing the options menu with a message when a user selects the maximum number of selectable options
    const getSelectSearchOptions = () => {
      if (getIsSearchOptionsDisabled()) {
        return [
          {
            value: "_@_maxOptions_@_",
            label: `You have selected the maximum number of options. Please remove some if you would like to change your selection.`
          }
        ];
      }
      return searchOptions.sort((a, b) => {
        const aHas = a.mScore !== undefined;
        const bHas = b.mScore !== undefined;
        return bHas - aHas || (aHas === true && b.mScore - a.mScore) || 0;
      });
    };

    return (
      <div
        id="nextSearch"
        className={
          isDashboard
            ? styles.dashboardSearch
            : isList
              ? styles.listSearch
              : isOnlySearch
                ? styles.onlySearch
                : styles.nextSearch
        }
        style={{
          ...searchStyle,
          ...(style || {})
        }}
        title={isReplay ? "Search not available during replay, please stop replay to search" : ""}
      >
        {this.renderMakeLiveModal()}
        <div
          className={styles.searchTop}
          style={
            searchTopStyle
              ? searchTopStyle
              : {
                  marginTop: lookerSDK !== undefined || hideMargins ? "0px" : undefined,
                  marginLeft: hideMargins ? "0px" : undefined
                }
          }
        >
          {(isDashboard || isOnlyValue) && !isWhatsChanged && (
            <div className={styles.dashboardTitle}>
              {false && nextDatasets && nextDatasets.length > 1 ? (
                <div className={styles.dashOutcome}>
                  <div className={styles.dashOutcomeSelect}>
                    <Select
                      options={nextDatasetOptions}
                      value={nextDatasetOptions.find((d) => d.label === dataset.outcome)}
                      onChange={(val) => initNextDashboard(originalId, val.value)}
                    />
                  </div>
                  {dataset?.target_value !== undefined && (
                    <div style={{ marginRight: "5px", marginLeft: "5px" }}>{":"}</div>
                  )}
                </div>
              ) : (
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", flexShrink: "1" }}>
                  {dataset?.outcome + ": "}
                </div>
              )}
              {dataset?.target_value !== undefined && (
                <div className={styles.nextTitleSelect} style={{ marginLeft: "10px" }}>
                  <Select
                    id="outcomeSuccessSelect"
                    options={successOptions ?? []}
                    menuPosition="fixed"
                    value={successOptions?.find((option) => {
                      if (datasetSuccess?.value !== undefined) {
                        return option?.value === datasetSuccess?.value;
                      }
                      return option?.value === datasetTargetValue;
                    })}
                    onChange={(val) => {
                      updateDatasetSuccess(val);
                    }}
                  />
                </div>
              )}
            </div>
          )}
          {isWhatsChanged && isDashboard && !isSimpleAgentAnalytics && (
            <div
              className={styles.dashboardTitle}
              style={{
                marginLeft: hideMargins ? "0px" : undefined,
                textWrap: "unset"
              }}
            >
              <ShadcnPopover>
                <PopoverTrigger>
                  <Button type="secondary">Date Range</Button>
                </PopoverTrigger>
                <PopoverContent className="size-fit">
                  <SmallDateChart
                    datasetId={dataset?.id}
                    field={field}
                    comparisonOptions={comparisonOptions}
                    updateComparisonOptions={(val) => updateComparisonOptions(id, val)}
                    hideText
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexGrow: 1,
                      width: "100%",
                      minHeight: "150px"
                    }}
                  >
                    <div style={{ fontSize: "13px", width: "calc(100% - 120px)" }}>
                      {dateRowsExcluded !== undefined && (
                        <div>
                          <div style={{ background: "#C8CAD4" }} />
                          <div>
                            <span style={{ fontWeight: "bold" }}>{dateRowsExcluded}</span>
                            <span style={{ marginLeft: "5px" }}>{getRowsIgnoredText()}</span>
                          </div>
                          <Tooltip
                            overlay={
                              <div>
                                {dateRowsExcluded > 0
                                  ? `Your Exploration will exclude data not in the reference or current periods`
                                  : `Your Exploration will not exclude any rows`}
                              </div>
                            }
                          />
                        </div>
                      )}
                      {dateRowsAfter !== undefined && (
                        <div>
                          <div>
                            <div style={{ background: "#8884d8" }} />
                            <div>
                              <span style={{ fontWeight: "bold" }}>{dateRowsBefore}</span>
                              <span style={{ marginLeft: "5px" }}>
                                {dateRowsBefore
                                  ? `rows from ${referenceStart} and ${referenceEnd} ` +
                                    `will be used for
                                the comparison period for what has changed
                                       `
                                  : "training rows"}
                              </span>
                            </div>
                            <Tooltip
                              overlay={
                                <div>
                                  {dateRowsBefore === dateFieldMax
                                    ? `Your Exploration will be created using all ${dateRowsBefore} rows`
                                    : `Your Exploration will be created using the ${dateRowsBefore} rows ` +
                                      `from ${referenceStart} to ${referenceEnd}` +
                                      (Boolean(dateRowsAfter) &&
                                        `and will compare them to the ${dateRowsAfter} rows ` +
                                          `from ${currentStart} to ${currentEnd}`)}
                                </div>
                              }
                            />
                          </div>
                          {dateRowsAfter !== undefined && (
                            <div>
                              <div style={{ background: "#34D399" }} />
                              <div>
                                <span style={{ fontWeight: "bold" }}>{dateRowsAfter}</span>
                                <span style={{ marginLeft: "5px" }}>
                                  {`rows from ${currentStart} and ${currentEnd} will be used for the current time period for what has changed`}
                                </span>
                              </div>
                              <Tooltip
                                overlay={
                                  <div>
                                    {dateAnalysisTarget === "EXPLORE" && (
                                      <div>
                                        <strong>{"If you are analyzing data, "}</strong>
                                        <span>
                                          {"these rows are the new data you're comparing your previous data to."}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                }
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      <PieChart width={100} height={100}>
                        <Pie data={pieData} labelLine={false} dataKey={"value"} paddingAngle={0}>
                          {pieData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} stroke={entry.color} />
                          ))}
                        </Pie>
                      </PieChart>
                    </div>
                  </div>
                </PopoverContent>
              </ShadcnPopover>
            </div>
          )}
          <div
            className={styles.searchSelect}
            style={
              searchSelectStyle
                ? searchSelectStyle
                : isDashboard
                  ? { width: "50%", minWidth: "300px" }
                  : isOnlySearch
                    ? isGoogleMode
                      ? { width: "calc(100% - 30px)" }
                      : { width: "calc(100% - 180px)" }
                    : {}
            }
          >
            <div
              className={styles.searchInner}
              style={isOverflowHidden ? { overflow: "visible" } : { overflow: "visible" }}
              onMouseMove={() => this.setState({ isOverflowHidden: false })}
              onMouseLeave={() => this.setState({ isOverflowHidden: true })}
            >
              <div className={styles.searchIconAbs}>
                <FontAwesomeIcon icon={faSearch} />
              </div>
              {searchType === "NLQ" ? (
                <LineInput
                  isFullBox
                  onChange={(val) => {
                    updateSearchNLQ(val);
                    if (isHideSearch) {
                      updateIsHideSearch(false);
                    }
                  }}
                  placeholder="What would you like to understand?"
                  // What happens with my life
                />
              ) : (
                <Select
                  filterOption={createFilter({ ignoreAccents: false })}
                  styles={{
                    control: (provided, state) => ({
                      ...provided,
                      paddingLeft: "20px"
                    }),
                    menu: (provided, state) => ({
                      ...provided,
                      marginTop: "-6px"
                    }),
                    clearIndicator: (provided, state) => ({
                      ...provided,
                      alignSelf: "flex-start"
                    })
                  }}
                  components={{ Option: CustomOption }}
                  // defaultMenuIsOpen={isDashboard ? true : false}
                  options={getSelectSearchOptions()}
                  isOptionDisabled={() => getIsSearchOptionsDisabled()}
                  onChange={(val) => {
                    const emptySearch = val === undefined || val.length === 0;

                    if (isHideSearch && emptySearch !== true) {
                      updateIsHideSearch(!isHideSearch);
                    }

                    handleSearchInsights(val, isDashboard || isOnlyValue);
                    this.setState(() => ({
                      searchValues: val
                    }));

                    if (emptySearch) {
                      updateIsHideSearch(true);
                    }

                    if (updateSearchColumnState) {
                      updateSearchColumnState(undefined);
                    }
                  }}
                  value={
                    showCollapsed && isOverflowHidden && searchOpts && searchOpts?.length > maxShownSearchOptions
                      ? [
                          ...searchOpts.slice(0, maxShownSearchOptions),
                          {
                            value: "_@_more_@_",
                            label: (searchOpts?.length ?? 0) - maxShownSearchOptions + " more terms"
                          }
                        ]
                      : searchOpts
                  }
                  isMulti
                  placeholder={
                    isSimpleAgentAnalytics
                      ? "Select insights to summarize"
                      : isOnlySearch && !isGoogleMode
                        ? dashboardLayout?.value === "INFO"
                          ? "Benchmark by"
                          : "Search Dashboard Insights"
                        : "Search Insights"
                  }
                  menuPlacement={menuPlacement}
                />
              )}
            </div>
          </div>
          {dashboardLayout?.value === "INFO" && (
            <div className={styles.reloadIgnore} style={{ marginLeft: "5px", marginTop: "2px" }}>
              <OverlayTrigger
                placement="top"
                trigger={["hover"]}
                rootClose
                overlay={
                  <Popover id="popover-positioned-top">
                    <div>{"Reset Dashboard Ignored Fields."}</div>
                  </Popover>
                }
              >
                <Button onClick={() => updateIgnoreInfoChartField({})}>
                  <FontAwesomeIcon icon={faUndo} />
                </Button>
              </OverlayTrigger>
            </div>
          )}
          {!isWhatsChanged && isGoogleMode && isEnabled("google-slides-export") && (
            <div style={{ marginLeft: "10px", whiteSpace: "nowrap" }}>
              {this.renderSlidesExport(
                "Export " +
                  (hasSearchInsights ? searchInsights.length + " Search Insights" : "Dashboard") +
                  " to Slides"
              )}
            </div>
          )}
          {isHideSearchType !== true &&
            isOnlyValue !== true &&
            !isWhatsChanged &&
            isDashboard !== true &&
            !isGoogleMode && (
              <div className={styles.searchtype}>
                <Select
                  options={
                    hasModelDrivers ? searchTypeOptions : searchTypeOptions.filter((s) => s?.value !== "ModelDriver")
                  }
                  value={searchTypeValue}
                  onChange={(val) => updateSearchType(val.value)}
                />
              </div>
            )}
          {isOnlySearch !== true && !isWhatsChanged && !isGoogleMode && (
            <div className={styles.minimumValueCountWrapper}>
              {this.state.showMinCountFilter || minimumValueCount !== undefined ? (
                <React.Fragment>
                  <div>{"Filter out values where the count is less than "}</div>
                  <div className={styles.minimumValueCountInput}>
                    <LineInput
                      isSenseBox
                      value={minimumValueCount ?? DEFAULT_MIN_EXPLORE_SAMPLE_SIZE}
                      onChange={(val) => {
                        if (!isNaN(val)) {
                          updateMinimumValueCount(Number(val));
                        }
                      }}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <a
                  className={styles.showMinCountFilter}
                  onClick={() => {
                    this.setState({
                      showMinCountFilter: true
                    });
                  }}
                >
                  {"Filter Value Counts"}
                </a>
              )}
            </div>
          )}
          {isOnlySearch !== true && isList !== true && (!isRetHide || (insights && insights.length !== 0)) ? (
            <Button onClick={() => updateIsHideSearch(!isHideSearch)} style={{ marginLeft: "10px" }}>
              {isHideSearch ? "Show" : "Hide"}
            </Button>
          ) : (
            <React.Fragment />
          )}
          {(isDashboard || isOnlyValue) && (
            <div
              className={styles.fButtons}
              style={{
                marginRight: hideMargins ? "0px" : undefined,
                minWidth: isWhatsChanged ? "500px" : undefined
              }}
            >
              {false && !isWhatsChanged && (
                <Button
                  onClick={() => updateSearchType(searchType === "NLQ" ? "All Insights" : "NLQ")}
                  active={searchType === "NLQ"}
                >
                  {"NLQ"}
                </Button>
              )}
              {isWhatsChanged ? (
                <React.Fragment>
                  <div className={styles.layoutLabel}>Sort by </div>
                  <WhatsChangedSortDropdown id={id} />
                  <div className={styles.layoutLabel}>and</div>
                  <div className={styles.layoutOptionsComparison} style={{ marginRight: "0" }}>
                    <Select
                      options={comparisonDashboardSortOrderOptions}
                      onChange={(val) => updateComparisonDashboardSortOrder(val)}
                      value={comparisonDashboardSortOrder}
                    />
                  </div>
                </React.Fragment>
              ) : (
                <div className={styles.layoutOptions}>
                  <Select
                    options={retDashboardLayoutOptions}
                    onChange={(val) => updateDashboardLayout(val)}
                    value={dashboardLayout}
                  />
                </div>
              )}
              {!isWhatsChanged && isOnlyValue !== true && (
                <Button
                  style={{ marginRight: "10px" }}
                  active={isShowAllDashboard === true}
                  onClick={() => updateIsShowAllDashboard(!isShowAllDashboard)}
                  greyscaleDefaultState
                >
                  {isShowAllDashboard === true ? "Hide Unpinned" : "Show All"}
                </Button>
              )}
              {!isWhatsChanged && isOnlyValue !== true && (
                <Button
                  style={{ marginRight: "10px" }}
                  active={isDomainMin !== true}
                  onClick={() => updateIsDomainMin(!isDomainMin)}
                  greyscaleDefaultState
                >
                  {"Start axis at 0"}
                </Button>
              )}
              {false && !isWhatsChanged && (
                <Button
                  style={{ marginRight: "10px" }}
                  onClick={() => this.setState({ isMakeLive: true })}
                  greyscaleDefaultState
                >
                  <FontAwesomeIcon icon={faRetweet} style={{ marginRight: "3px" }} />
                  {"Make Live"}
                </Button>
              )}
              {!isWhatsChanged && isEnabled("google-slides-export") && this.renderSlidesExport("Export to Slides")}
              {isWhatsChanged || isEnabled("looker-export") !== true ? (
                <div />
              ) : isExportingLooker ? (
                <LoadingIndicator style={{ margin: "0px" }} />
              ) : isLookerValid ? (
                <Button
                  onClick={(e) => {
                    e.stopPropagation();
                    exportToLooker();
                  }}
                  greyscaleDefaultState
                >
                  <img src={LookerIcon} style={{ margin: "0 9px 0 -4px" }} />
                  {"Looker"}
                </Button>
              ) : (
                <OverlayTrigger
                  placement="top"
                  trigger={["hover"]}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-top">
                      <div>
                        {"Looker Export Disabled. To ensure that your data remains secure, " +
                          "Looker export requires that the data reside in a GCP cloud account " +
                          "and cannot be from a linked BigQuery datasource."}
                      </div>
                    </Popover>
                  }
                >
                  <Button
                    onClick={(e) => {
                      e.stopPropagation();
                      exportToLooker();
                    }}
                    disabled={!isLookerValid}
                  >
                    <img src={LookerIconDisabled} style={{ margin: "0 9px 0 -4px" }} />
                    {"Looker"}
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          )}
          {isChatColumnSelect !== true &&
            isWhatsChanged &&
            !isSimpleAgentAnalytics &&
            !(activeTab === "EXPLORE" || dashboardLayout?.value === "INFO") && (
              <div style={{ marginRight: "16px" }}>
                <Dropdown
                  open={this.state.showWhatsChangedDropdown}
                  pullRight
                  onToggle={(e, metadata, sourceObj) => {
                    // This is to prevent the dropdown from closing when the user clicks on the input fields in there
                    // LineInput uses the `select` method which triggers the toggle behavior so we can't just stopPropagation ComparisonChartOptions
                    if (sourceObj?.source !== "select") {
                      this.setState({ showWhatsChangedDropdown: e });
                    }
                  }}
                >
                  <Dropdown.Toggle
                    noCaret
                    style={{
                      fontWeight: "normal",
                      marginLeft: "auto",
                      fontSize: "16px",
                      padding: "9px"
                    }}
                  >
                    <Icon type={"gear"} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <div style={{ padding: "0px 10px" }}>
                      <ComparisonChartOptions
                        id={id}
                        comparisonOptions={comparisonOptions}
                        comparisonChartOptions={comparisonChartOptions}
                        updateComparisonChartOptions={updateComparisonChartOptions}
                        useReportIdForChatGPTReducer={useReportIdForChatGPTReducer}
                      />
                      <div
                        className={styles.comparisonChartCheckboxWrapper}
                        onClick={() => updateShowHiddenCharts(!showHiddenCharts)}
                      >
                        <input
                          type="checkbox"
                          checked={showHiddenCharts}
                          readOnly={true}
                          style={{ margin: "-2px 6px 0px 0px" }}
                        />
                        View Ignored Charts
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
                {/* <OverlayTrigger
                  placement="bottom"
                  trigger={"click"}
                  rootClose
                  overlay={
                    <Popover id="popover-positioned-bottom">
                      <ComparisonChartOptions
                        id={id}
                        comparisonOptions={comparisonOptions}
                        comparisonChartOptions={comparisonChartOptions}
                        updateComparisonChartOptions={updateComparisonChartOptions}
                      />
                    </Popover>
                  }
                >
                  <Button
                    style={{
                      fontWeight: "normal",
                      marginLeft: "auto",
                      fontSize: "16px",
                      padding: "9px"
                    }}
                  >
                    <Icon type={"gear"} />
                  </Button>
                </OverlayTrigger> */}
              </div>
            )}
          {(activeTab === "EXPLORE" || dashboardLayout?.value === "INFO") && (
            <div style={{ marginRight: "16px", marginLeft: activeTab === "EXPLORE" ? "10px" : "0px" }}>
              <OverlayTrigger
                placement="bottom"
                trigger={"click"}
                rootClose
                overlay={
                  // Warning: This loses context of the redux provider.
                  // We need to convert this to a dropdown if we want to pass in components
                  // Refer to the Dropdown above for the `ComparisonChartOptions`
                  <Popover id="popover-positioned-bottom">
                    <div className={styles.hideMissingOption}>
                      <input
                        style={{ marginTop: "0px", marginRight: "5px" }}
                        type={"checkbox"}
                        checked={hideMissingInCharts === true}
                        onChange={() => updateHideMissingInCharts(!hideMissingInCharts)}
                      />
                      <div>{"Hide {Missing} Charts"}</div>
                    </div>
                    <div className={styles.hideMissingOption}>
                      <input
                        style={{ marginTop: "0px", marginRight: "5px" }}
                        type={"checkbox"}
                        checked={hideOtherInCharts === true}
                        onChange={() => updateHideOtherInCharts(!hideOtherInCharts)}
                      />
                      <div>{"Hide {Other} Charts"}</div>
                    </div>
                    {dashboardLayout?.value === "INFO" && (
                      <div className={styles.hideMissingOption} style={{ marginTop: "10px" }}>
                        <div style={{ width: "50px" }}>
                          <LineInput
                            style={{ marginTop: "0px", marginRight: "5px" }}
                            value={dashboardSubchartsCount}
                            onChange={(val) => updateDashboardSubchartsCount(val)}
                            type="number"
                            min={3}
                            max={30}
                          />
                        </div>
                        <div>{"# of Dashboard Subcharts"}</div>
                      </div>
                    )}
                  </Popover>
                }
              >
                <Button
                  style={{
                    fontWeight: "normal",
                    marginLeft: "auto",
                    fontSize: "16px",
                    padding: "9px"
                  }}
                >
                  <Icon type={"gear"} />
                </Button>
              </OverlayTrigger>
            </div>
          )}
          {isGoogleMode !== true && isDashboard !== true && !isWhatsChanged && isEnabled("google-slides-export") && (
            <div className={styles.slidesExport}>
              {this.renderSlidesExport(
                "Export " +
                  (searchInsights && searchInsights.length > 0
                    ? searchInsights.length + " Search "
                    : pinnedHexList.length + " Report ") +
                  "Insights to Google Slides"
              )}
            </div>
          )}
        </div>
        {isOnlySearch !== true && isList !== true && (
          <div className={styles.searchContent} style={isRetHide ? { height: "0px" } : { height: "250px" }}>
            {(insights ?? []).map((insight, i) => (
              <HexagonContainer
                id={id}
                node={{
                  chart: insight,
                  fields: insight.fields,
                  isSearch: true
                }}
                useLocation
                hex={{}}
                isSearch={true}
                key={"search_" + i}
              />
            ))}
          </div>
        )}
      </div>
    );
  }

  renderMakeLiveModal() {
    const { updateRefreshRate, refreshRate } = this.props;
    const { isMakeLive, tempRefreshRate } = this.state;

    return (
      <Dialog open={isMakeLive !== undefined} onOpenChange={() => this.setState({ isMakeLive: undefined })}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Make Dashboard Live</DialogTitle>
          </DialogHeader>
          <div className={styles.modalBody}>
            <div className={styles.smallBold}>{"How often would you like your Dashboard to update?"}</div>
            <div className={styles.refreshSelect}>
              <Select
                styles={{
                  menuList: (provided, state) => ({
                    ...provided,
                    maxHeight: "200px"
                  })
                }}
                options={DATASET_REFRESH_RATE_OPTIONS}
                menuPlacement={"top"}
                onChange={(val) => this.setState({ tempRefreshRate: val })}
                value={refreshRate}
              />
            </div>
          </div>
          <DialogFooter>
            <Button
              type="secondary"
              onClick={() => this.setState({ isMakeLive: undefined })}
              style={{ marginRight: "auto" }}
            >
              {"Close"}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                updateRefreshRate(tempRefreshRate);

                this.setState({
                  isMakeLive: undefined,
                  tempRefreshRate: undefined
                });
              }}
            >
              {"Save"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}

const WhatsChangedSortDropdown = ({ id }) => {
  const dispatch = useDispatch();

  const sortOptions = useSelector((state) => nextReducer.getComparisonDashBoardSortOptions(state, id));
  const comparisonDashboardSort = useSelector((state) => nextReducer.getComparisonDashBoardSort(state, id));
  const updateDashboardLayout = (dashboardLayout) => dispatch(nextReducer.updateDashboardLayout(id, dashboardLayout));

  const selectedDashboardSort = sortOptions.find((o) => o?.value === comparisonDashboardSort?.value);

  useEffect(() => {
    if (!selectedDashboardSort && sortOptions?.length > 0) {
      updateDashboardLayout(sortOptions[0]);
    }
  }, [sortOptions]);
  return (
    <div className={styles.layoutOptionsComparison} style={{ width: "210px" }}>
      <Select options={sortOptions} onChange={(val) => updateDashboardLayout(val)} value={selectedDashboardSort} />
    </div>
  );
};
